import React from 'react';
import DashboardDatePickers, {
  SelectedDateRange
} from './dashboard/date-range-selector/datePicker';
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { CalendarDaysIcon } from '@heroicons/react/24/solid';

const DateRangeSelectorModal = ({  onClose,onCheck}: { onClose: () => void; onCheck: (data:any) => void;
}) => {
  return (
    <div>
      <div className="bg-primary-main flex justify-between">
        <div className="p-[1rem] flex justify-between w-full items-center">
          <div className="flex items-center justify-center gap-5">
            <div className="flex items-center justify-center bg-white p-2 rounded-full">
              <CalendarDaysIcon className="h-4 w-4" />
            </div>
            <h2 className="font-[gilroy-bold] text-lg">Select Date Range</h2>
          </div>
          <XMarkIcon onClick={onClose} width={'18px'} height={'18px'} className="cursor-pointer" />
        </div>
      </div>
      <div className="p-5">
        <DashboardDatePickers
          onSubmit={(data: SelectedDateRange) => {
            onCheck(data)
          }}
        />
      </div>
    </div>
  );
};

export default DateRangeSelectorModal;
